import { useRouter } from "next/router";
import parse from "html-react-parser";
import find from "lodash/find";
import TreeItem from "@material-ui/lab/TreeItem";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    height: "auto",
    flexGrow: 1,
    maxWidth: "100%",
    color: "maroon",
    fontSize: "25px",
    fontFamily: "Lato",
  },
  treeItem: {
    marginTop: "10px",
    fontFamily: "Lato",
    fontSize: "25px",
  },
  subItem: {
    marginTop: "10px",
    marginLeft: "2%",
    fontFamily: "Lato",
    fontSize: "25px",
  },
});

const CategoryDrawer = ({ closeFilterDrawer, productCategories }) => {
  const router = useRouter();

  const catDictionary = {};
  const primaryCategories = productCategories.filter((cat) => !cat.parent);

  primaryCategories.forEach((obj) => {
    obj.subCategory = [];
    catDictionary[obj.slug] = obj;
  });

  productCategories.forEach((obj) => {
    if (obj.parent) {
      const parentCategory = find(
        primaryCategories,
        (category) => category.id === obj.parent
      );
      catDictionary[parentCategory.slug].subCategory.push(obj);
    }
  });

  const classes = useStyles();
  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {Object.keys(catDictionary).map((key) => {
        const parentCategory = catDictionary[key];
        return (
          <TreeItem
            key={parentCategory.id}
            nodeId={parentCategory.id.toString()}
            className={classes.subItem}
            label={parse(parentCategory.name)}
          >
            {parentCategory.subCategory.map((childCategory) => (
              <TreeItem
                key={childCategory.id}
                nodeId={childCategory.id.toString()}
                label={parse(childCategory.name)}
                className={classes.subItem}
                onClick={() => {
                  router.push(
                    `/product-category/${parentCategory.slug}/${childCategory.slug}`
                  );
                  closeFilterDrawer();
                }}
              />
            ))}
          </TreeItem>
        );
      })}
    </TreeView>
  );
};
export default CategoryDrawer;
